<template>
  <div class="card_title_container" @click="skipPageHandle">
    <div class="title_left">
      <div class="dot"></div>
      <span class="text">{{ title }}</span>
      <span class="badge" v-if="badgeNum !== -1">{{ badgeNum }}</span>
    </div>
    <div class="title_right">
      <span class="text">{{ $t('app_more') }}</span>
      <i class="iconfont icon-icon_shouye_tiaozhuan"></i>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useThemeColor, useThemeColorWithAlpha } from '@/utils/theme'
import { useRouter } from 'vue-router'

interface TProps {
  title: string
  badgeNum?: number
  skipPage: string
}
const props = withDefaults(defineProps<TProps>(), {
  badgeNum: -1
})

const themeColor = useThemeColor()
const themeColorWithAlpha = useThemeColorWithAlpha(0.1)

const router = useRouter()
const skipPageHandle = () => {
  if (props.skipPage.startsWith('/broadcast')) { // 跳转资讯，需要传入Title
    router.push(props.skipPage + '&title=' + props.title)
  } else {
    router.push(props.skipPage)
  }
}
</script>

<style lang="less" scoped>
@import url('@/styles/variables.less');

.card_title_container {
  padding-top: 15px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 2;
  .title_left {
    display: flex;
    position: relative;
    flex: 1;
    .dot {
      width: 17px;
      height: 17px;
      position: absolute;
      left: 0;
      top: 0;
      border-radius: 50%;
      background: linear-gradient(to right, v-bind(themeColor), v-bind(themeColorWithAlpha));
    }
    .text {
      padding-left: 9px;
      color: @textPrimary;
      font-size: 18px;
      position: relative;
      z-index: 2;
      font-weight: 600;
    }
    .badge {
      min-width: 16px;
      height: 16px;
      padding: 0 2px;
      margin-top: -4px;
      margin-left: -3px;
      font-size: 12px;
      background-color: #ef3838;
      border-radius: 16px;
      color: @textWhite;
      .flex_center;
    }
  }
  .title_right {
    display: flex;
    align-items: center;
    color: @textSecondary99;
    .text {
      font-size: 14px;
    }
    .iconfont {
      margin-left: 3px;
      font-size: 12px;
    }
  }
}
</style>
